<template>
    <div  class="mb-md-4 main" v-if="detailData">
        <div class="d-flex align-items-center mb-2 label_box">
            <label class="mb-0">{{label}}</label>
            <router-link :to="localePath('/how-to-find-ring-size')" v-if="['size', 'her_size', 'his_size'].includes(attr)">
                <SvgHeaderSvg class="ms-2" :type="'ask'" />
            </router-link>
            <ModalBackType v-if="attr === 'back_type'" />
            <ModalChainLength v-if="attr === 'chain_length' && detailData.sub_type != 'tennis-bracelet' " />
            <ModalChainLengthTwo v-if="attr === 'chain_length' && detailData.sub_type === 'tennis-bracelet'" />
        </div>
        <div v-if="dropdownOptions" class="drop_block" :class="{ 'invalid': mode }" v-click-outside="()=> showOptions = false">
            <div class="current_active" @click="showOptions = !showOptions">
                <div class="d-flex align-items-center">
                    <SvgMetalSvg v-if="currentActive && currentActive.icon != null" :type="currentActive.icon" />
                    <span v-if="!currentActive"> select</span>
                    <span v-else>{{currentActive.label}}</span>
                    <span v-if="currentActive && currentActive.default && currentActive.default === 1">&nbsp;(default)</span>
                </div>
                <SvgHeaderSvg v-if="!showOptions" :type="'down'" />
                <SvgHeaderSvg v-else :type="'up'" />
            </div>
            <ul class="p-0" v-show="showOptions">
                <li v-for="list in dropdownOptions"
            
                    :key="list.value + list.icon"
                    @click="toggleOption(list.value)"
                    :class="{'active': list.selected === 1, 'disabled': list.visibility === 0}"
                >
               
                    <SvgMetalSvg v-if="list.icon != null" :type="list.icon" />
                    <span>{{list.label}}</span>
                    <span v-if="list.default && list.default === 1">&nbsp;(default)</span>
                </li>
            </ul>
        </div>
        <div v-else class="skeleton"></div>
        
        <div class="error_boxx" v-if="mode">{{ mode.join(" ") }}</div>

        <p class="mb-0 pt-1" v-if="detailData.sub_type === 'full-eternity-ring' && attr === 'size'" >* Eternity rings cannot be resized. <router-link :to="localePath('/customer-service/ring-resizing')">Read more</router-link></p>

    </div>
 
</template>

<script setup>
    import { ClickOutsideDirective as vClickOutside } from '@/directives/ClickOutsideDirective';

    import { shopdetailStore }  from '@/stores/shop_detail/shop_detail';
    const store = shopdetailStore()

    const localePath = useLocalePath();
    const route = useRoute()

    const { type, label, mode, attr } = defineProps(['type', 'label', 'mode', 'attr'])

    const showOptions = ref(false)

    const detailData = computed(() => {
        return store.getDetailData
    })

    const dropdownOptions = computed(() => {
        return store.getDropDownList(type)
    })

    const currentActive = computed(() => {
        return store.getCurrentActive(type)
    })


    function toggleOption(value){
        store.setActive({ value: value, type: type })
        showOptions.value = false

        // if( type == 'metal' || type == 'carat' ){
        //     const carat = store.getCurrentActive('carat')
        //     history.pushState({}, "/", carat.slug+'?FastShip='+route.query.FastShip);
        // }
       
    }

</script>

<style scoped>


  .skeleton {
        height: 42px;
        border-radius: 8px;
        background: #eaeaea;
        min-width: 85px;
    }
.current_active .svg-head {
    height: 12px;
    width: 20px;
}
p{
    font-size: 12px;
    font-weight: 600;
}
p a{
    color: var(--green);
}

.drop_block.invalid .current_active {
    border: 1px solid rgb(255, 2, 2);
}
.label_box {
    font-size: 14px;
    font-weight: 600;
    text-transform: capitalize;
    color: #212529;
}
.label_box div{
    color: rgb(159, 158, 158);
    cursor: pointer;
}
label{
    color: #303030;
    font-size: 16px;
    font-weight: 600;
}
.drop_block{
    position: relative;
}
.current_active {
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 1.5;
    color: #000;
    vertical-align: middle;
    border: 1px solid #c4c4c4;
    padding: 0 10px;
    font-size: 14px;
    cursor: pointer;
    height: 44px;
    border-radius: 8px;
}


.current_active.focused {
    border-color: var(--green);
    box-shadow: 0 0 0 0.2rem rgb(112 192 153 / 25%);
}
ul {
    border: 1px solid #c4c4c4;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background: #fff;
    z-index: 9;
    padding: 10px 0;
    max-height: 210px;
    overflow: auto;
    border-radius: 8px;
}
ul li{
    list-style: none;
    padding: 5px 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    text-transform: capitalize;
}
ul li.active {
    background: rgba(204,204,204,0.36863);
}
ul li.disabled {
    opacity: 0.4;
    pointer-events: none;
}
span{
    font-weight: 400;
    font-size: 14px;
    color: #212529;
    text-transform: capitalize;
}

@media(max-width:768px){
    .main{
        padding: 20px 0px;
    }

    label{
        font-size: 14px;
    }
}

</style>
